import type { GameCommand, GameState } from '../core/types';
import { parseSave, serializeSave } from '../saves/storage';

export interface IronveinBrowserControl {
  readonly version: 1;
  getState: () => GameState;
  dispatch: (command: GameCommand) => boolean;
  replaceState: (state: GameState) => void;
}

declare global {
  interface Window {
    __IRONVEIN__?: IronveinBrowserControl;
  }
}

export function exposeBrowserControl(
  getState: () => GameState,
  send: (command: GameCommand) => boolean,
  replaceState: (state: GameState) => void,
): () => void {
  if (!import.meta.env.DEV || typeof window === 'undefined') return () => undefined;

  const control: IronveinBrowserControl = {
    version: 1,
    getState: () => structuredClone(getState()),
    dispatch: send,
    replaceState: (state) => replaceState(parseSave(serializeSave(state))),
  };
  window.__IRONVEIN__ = control;

  return () => {
    if (window.__IRONVEIN__ === control) delete window.__IRONVEIN__;
  };
}
